import {useEffect, useState} from "react";
import {buildErrors, SEVERITYSIDEPANEL} from "../../../state/slices/CoreEntity";
import PropTypes from "prop-types";
import * as c from "../../../constants";

export const determineSeverityClass = (severity) => {
    switch (severity) {
        case SEVERITYSIDEPANEL.CRITICAL:
            return "critical";
        case SEVERITYSIDEPANEL.WARNING:
            return "warning";
        case SEVERITYSIDEPANEL.LOW:
            return "low";
        case SEVERITYSIDEPANEL.WORLD_IS_ON_FIRE:
            return "fire";
        case SEVERITYSIDEPANEL.INFO:
            return "info";
        default:
            return "low";
    }
}
// TODO: Possible future logic not sure if needed
export const determineSeverity = (selectedEntity, isBeingListened) => {

    if (!selectedEntity &&
        (!isBeingListened && selectedEntity?.typeid !== c.ENTITY_TYPE.Device) ||
        selectedEntity?.typeid !== c.ENTITY_TYPE.Device) return null;

    const errors = buildErrors(selectedEntity);
    if (errors.length < 0) return null;

    let highestSeverity = {
        Type: c.ERROR_TYPES.Device,
        Severity: SEVERITYSIDEPANEL.INFO,
        Message: "Unable to Determine Severity",
    }; // Default to LOW if no errors found

    for (const error of errors) {
        if (error.Severity > highestSeverity.Severity) {
            highestSeverity = error;
        }
    }

    return {
        errorCount: errors.length,
        severity: highestSeverity.Severity,
        Message: highestSeverity.Message,
        class: determineSeverityClass(highestSeverity.Severity),
    };
};

export const useSeverityState = (severity) => {
    const [severityClass, setSeverityClass] = useState(null);

    useEffect(() => {
        if (!severity) return;

        setSeverityClass(determineSeverityClass(severity.highestSeverity));
    }, [severityClass, severity]);

    return severityClass;
}

useSeverityState.PropTypes = {
    entityId: PropTypes.string
};